import { createFileRoute } from '@tanstack/react-router'
import { OverviewCalendar } from '@/components/today'
import { useTaskMuteHydrate } from '@/hooks/use-task-mute-hydrate'
import { useMeetingMuteHydrate } from '@/hooks/use-meeting-mute-hydrate'

export const Route = createFileRoute('/(app)/productivity/today/')({
	component: RouteComponent,
})

function RouteComponent() {
	// Today shows both task and meeting cards, so hydrate both mute caches here.
	useTaskMuteHydrate()
	useMeetingMuteHydrate()
	return <OverviewCalendar />
}
